import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMonitoring = createAsyncThunk(
    "monitoring/get",
    async ({start, count, Nik, TanggalAwal, TanggalAkhir}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("Nik", Nik);
        formData.append("TanggalAwal", TanggalAwal);
        formData.append("TanggalAkhir", TanggalAkhir);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMonitoring",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    data: [],
    isMonitoringFetching: false,
    isMonitoringSuccess: false,
    isMonitoringError: false,
};

export const monitoringSlice = createSlice({
    name: "monitoring",
    initialState,
    reducers: {},
    extraReducers: {
        [getMonitoring.fulfilled]: (state, {payload}) => {
            state.isMonitoringFetching = false;
            state.isMonitoringSuccess = true;
            state.message = payload.message;
            state.data = payload.data;
            return state;
        },
        [getMonitoring.rejected]: (state, {payload}) => {
            state.isMonitoringFetching = false;
            state.isMonitoringError = true;
            state.errorMessage = payload.message;
        },
        [getMonitoring.pending]: (state) => {
            state.isMonitoringFetching = true;
        },
    },
});

export const monitoringSelector = (state) => state.monitoring;
